import { render } from "./TestingBuild.vue?vue&type=template&id=4a380e18&ts=true"
import script from "./TestingBuild.vue?vue&type=script&lang=ts"
export * from "./TestingBuild.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__